/* Mi Buen Día MX · carrito: envío gratis, confianza y fecha de entrega (versión México, sin precios en euros). */
(function(){
  function addBiz(d,n){d=new Date(d);var a=0;while(a<n){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)a++;}return d;}
  var MES=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  function fd(d){return d.getDate()+' '+MES[d.getMonth()];}
  var E1=7,E2=12;
  function fixEta(){
    var el=document.querySelector('.am-eta'); if(!el||el.getAttribute('data-am-biz')) return;
    var n=new Date(), s1=addBiz(n,1), s2=addBiz(n,3), d1=addBiz(n,E1), d2=addBiz(n,E2);
    var h=el.querySelector('.am-eta__head'); if(h) h.innerHTML='Pide hoy y recíbelo entre el <strong>'+fd(d1)+'</strong> y el <strong>'+fd(d2)+'</strong>';
    var sp=el.querySelectorAll('.am-eta__s span:not(.am-eta__ic)'); if(sp.length>=3){ sp[1].textContent=fd(s1)+' – '+fd(s2); sp[2].textContent=fd(d1)+' – '+fd(d2); }
    el.setAttribute('data-am-biz','1');
  }
  var css=document.createElement('style');
  css.textContent='#am-fsbar{margin:14px var(--cart-drawer-padding,20px) 6px;padding:12px 14px;border-radius:8px;background:#e3ebe5;color:#1f2a2e;font-size:14px}#am-fsbar p{margin:0}#am-trust{display:flex;flex-wrap:wrap;justify-content:center;gap:6px 14px;padding:10px var(--cart-drawer-padding,20px) 16px;font-size:12px;color:#5b6669}';
  document.head.appendChild(css);
  function ensure(id,parent){ var x=document.getElementById(id); if(!x){ x=document.createElement('div'); x.id=id; } return x; }
  function render(){
    var content=document.querySelector('#cart-drawer .cart-drawer__content');
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
      if(!content||c.item_count===0){ ['am-fsbar','am-trust'].forEach(function(i){var e=document.getElementById(i); if(e) e.remove();}); return; }
      var bar=ensure('am-fsbar',content); var html='<p>🚚 <b>¡Tienes envío GRATIS!</b> Tu pedido llega con número de guía.</p>';
      if(bar.innerHTML!==html) bar.innerHTML=html;
      if(bar.parentNode!==content || content.firstElementChild!==bar) content.insertBefore(bar,content.firstChild);
      var now=new Date(), d1=addBiz(now,E1), d2=addBiz(now,E2);
      var th='<span>🔒 Pago seguro</span><span>🛡️ 30 días de garantía</span><span>📦 Llega entre el '+fd(d1)+' y el '+fd(d2)+'</span>';
      var tr=ensure('am-trust',content); if(tr.innerHTML!==th) tr.innerHTML=th;
      if(tr.parentNode!==content || tr!==content.lastElementChild) content.appendChild(tr);
    }).catch(function(){});
  }
  var to; function sched(){ clearTimeout(to); to=setTimeout(render,250); }
  function init(){
    var d=document.getElementById('cart-drawer');
    if(d){ new MutationObserver(function(ms){
      for(var i=0;i<ms.length;i++){ var n=ms[i].target; if(!(/^am-/.test(n.id||'')||(n.closest&&n.closest('#am-fsbar,#am-trust')))){ sched(); return; } }
    }).observe(d,{childList:true,subtree:true,attributes:true,attributeFilter:['open']}); }
    sched(); fixEta();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('cart:update',sched);
  document.addEventListener('shopify:cart:lines-update',sched);
})();
